import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.98 22H14.03C13.46 22 13.01 21.54 13.01 20.98V15H11.01V20.98C11.01 21.55 10.55 22 9.99 22H5.02C4.45 22 4 21.54 4 20.98V12H2L12 2L22 12H20V20.98C20 21.55 19.54 22 18.98 22ZM15 20H18V10.83L12 4.83L6 10.83V20H9V13H15V20Z" fill={ fill || 'currentColor' } />
    </svg>
);
